import ContinuousSchemeWrapper from './ContinuousSchemeWrapper';
export default class SequentialSchemeWrapper extends ContinuousSchemeWrapper {}